import { createInjectionState } from '@vueuse/core'
import { computed, shallowRef } from 'vue'

const [useProvideQuickConversation, _useQuickConversation] = createInjectionState((props) => {
  const candidateResponses = computed(() => props.candidateResponses)
  const candidateResponsesClicked = shallowRef([])

  return {
    candidateResponses,
    candidateResponsesClicked
  }
})

function useQuickConversation () {
  const res = _useQuickConversation()
  if (!res) {
    throw new Error('useQuickConversation() is called without provider.')
  }
  return res
}

export {
  useQuickConversation,
  useProvideQuickConversation
}
